import { Table, TableBody, TableContainer, TableHead } from '@mui/material';
import { memo, useMemo } from 'react';
import { SelloutProductColor } from '../../../../../../../../../../../../services/modules/product-color-sellout/product-color-sellout.types';
import { useSelloutTableConfig } from '../../../../../hooks/useSelloutTableConfig';
import SelloutDistributionRow from '../../../../distribution/components/SelloutDistributionRow';
import { SelloutDistribution } from '../../../../distribution/types/selloutDistribution.types';
import useSelloutTableStyles from '../styles/selloutTable.styles';
import SelloutTableHeader from './SelloutTableHeader';
import SelloutTableRow from './SelloutTableRow';

interface SelloutTableProps {
  pieces: number;
  disabled: boolean;
  distribution: SelloutDistribution[];
  selloutProductColor: SelloutProductColor;
  onChangePieces: (value: number) => void;
}

const SelloutTable = ({
  pieces,
  disabled,
  distribution,
  selloutProductColor,
  onChangePieces,
}: SelloutTableProps) => {
  const { classes } = useSelloutTableStyles();
  const { sortedSkuBySizePosition, tableRowsConfig } = useSelloutTableConfig({
    selloutProductColor,
  });

  const sizeNames = useMemo(
    () => sortedSkuBySizePosition.map((sku) => sku.sizeName),
    [sortedSkuBySizePosition],
  );

  return (
    <TableContainer>
      <Table className={classes.table} role="table">
        <TableHead>
          <SelloutTableHeader sizeNames={sizeNames} />
        </TableHead>

        <TableBody>
          {tableRowsConfig.map((config) => (
            <SelloutTableRow key={config.titleKey} data={config.data} />
          ))}

          <SelloutDistributionRow
            pieces={pieces}
            disabled={disabled}
            distribution={distribution}
            selloutSkus={sortedSkuBySizePosition}
            onChangePieces={onChangePieces}
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default memo(SelloutTable);
